import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Button from "components/molecules/Button";
import Switch from "components/molecules/Switch";

export const StyledPricingOffers = styled.div`
    width: 100%;
    .title {
        color: var(--text-color);
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
        margin-bottom: 10px;
        &:first-child {
            margin-bottom: 30px;
        }
    }
    .field-wrap {
        @media (min-width: 576px) {
            display: flex;
            gap: 18px;
        }
    }
    .sub-title {
        display: block;
        color: rgba(119, 119, 119, 1);
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        margin-bottom: 20px;
    }
    .btn-holder {
        @media (min-width: 576px) {
            display: flex;
            gap: 21px;
        }
        .btn {
            width: 100%;
            &:first-child {
                @media (max-width: 575px) {
                    margin-bottom: 10px;
                }
            }
        }
    }
    .input-field-wrap {
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
    }
    .switch-wrap {
        gap: 15px;
        margin-bottom: 40px;
        .checkbox-label-title {
            color: var(--text-color);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }
        .switch {
            width: 40px;
            height: 24px;
        }
    }

    .add-ons-list {
        list-style: none;
        li {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 16px;
            padding: 15px;
            border: 1px solid rgba(236, 236, 236, 1);
            border-radius: 60px;
            margin-bottom: 15px;
            &:last-child {
                margin-bottom: 30px;
            }
            &.active {
                background-color: rgba(245, 126, 42, 0.1);
                border: 1px solid rgba(245, 126, 42, 0.15);
            }
            .item-name {
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .price {
                padding: 7px 10px;
                border-radius: 30px;
                color: rgba(119, 119, 119, 1);
                border: 1px solid rgba(205, 205, 205, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
            }
            .input-field-wrap {
                margin-bottom: 0;
                label {
                    margin-bottom: 0;
                }
            }
        }
    }

    .summary {
        padding: 20px 15px;
        border-radius: 15px;
        background-color: rgba(44, 185, 255, 0.1);
        margin-bottom: 40px;
        .summary-title {
            display: block;
            color: rgba(44, 185, 255, 1);
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 10px;
        }
        .subTitle {
            display: block;
            color: rgba(44, 185, 255, 1);
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            margin-bottom: 10px;
        }
        .price-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            margin-bottom: 15px;
            color: var(--text-color);
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            .price {
                font-size: 16px;
                line-height: 20px;
            }
        }
        .separator {
            border-bottom: 1px solid rgba(44, 185, 255, 1);
            margin-bottom: 15px;
        }
        .addOns {
            list-style: none;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 15px;
            .addOn {
                padding: 7px 10px;
                border-radius: 30px;
                color: rgba(119, 119, 119, 1);
                border: 1px solid rgba(205, 205, 205, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
            }
        }
    }
`;

const addOns = ["Extra Cheese", "Bacon", "Extra Sauce", "Large Size Upgrade", "Extra Patty"];

const PricingOffers = ({setActiveTab, formData, setFormData}) => {
    const [form] = useForm();
    const [checkboxes, setCheckboxes] = useState({});
    const [basePrice, setBasePrice] = useState("0.00");

    useEffect(() => {
        if (formData?.form3) {
            form.setFieldsValue({
                comboPrice: formData?.form3?.comboPrice,
                originalPrice: formData?.form3?.originalPrice,
                savingPercentage: formData?.form3?.savingPercentage,
            });
        }
    }, [form, formData?.form3]);

    useEffect(() => {
        setBasePrice(form?.getFieldValue("comboPrice"));
    }, [basePrice, form]);

    async function handleSubmit(e) {
        const step3 = {
            comboPrice: e?.comboPrice,
            originalPrice: e?.originalPrice,
            savingPercentage: e?.savingPercentage,
        };
        try {
            await setFormData(prev => ({...prev, form3: {...step3}}));
            setActiveTab(3);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <StyledPricingOffers>
            <h2 className="title">Combo Pricing</h2>
            <Form form={form} onSubmit={handleSubmit}>
                <div className="field-wrap">
                    <Form.Item
                        label="Combo Price *"
                        $bgWhite
                        type="text"
                        name="comboPrice"
                        placeholder="0.00"
                        rules={[
                            {
                                required: true,
                                message: "Combo Price is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>

                    <Form.Item label="Original Price" $bgWhite type="text" name="originalPrice" placeholder="0.00">
                        <Field />
                    </Form.Item>
                </div>

                <Form.Item
                    label="Show savings percentage to customers"
                    switchFirst
                    successSwitch
                    $bgWhite
                    type="switch"
                    name="savingPercentage">
                    <Switch />
                </Form.Item>
                <h2 className="title">Optional Add-ons</h2>
                <span className="sub-title">Allow customers to customize their combo with additional items</span>

                <ul className="add-ons-list">
                    {addOns?.map((data, index) => {
                        let item = data.replace(/\s/g, "");
                        return (
                            <li key={index} className={checkboxes[item] === true ? "active" : ""}>
                                <Field
                                    label={<span className="item-name">{data}</span>}
                                    type="checkbox"
                                    name={item}
                                    value={checkboxes[item] === true}
                                    onChange={() =>
                                        setCheckboxes(prev => ({
                                            ...prev,
                                            [item]: !prev[item],
                                        }))
                                    }
                                />
                                <span className="price">+$1.50</span>
                            </li>
                        );
                    })}
                </ul>

                <div className="summary">
                    <strong className="summary-title">Pricing Summary</strong>
                    <span className="price-wrap">
                        Combo Base Price:
                        <span className="price">${basePrice}</span>
                    </span>
                    <div className="separator"></div>
                    <strong className="subTitle">Available Add-ons:</strong>
                    <ul className="addOns">
                        <li className="addOn">Extra Cheese</li>
                    </ul>
                </div>

                <div className="btn-holder">
                    <Button type="button" $gray className="btn" onClick={() => setActiveTab(1)}>
                        Previous
                    </Button>
                    <Button className="btn">Next</Button>
                </div>
            </Form>
        </StyledPricingOffers>
    );
};

export default PricingOffers;
